import Typography from '../../../../components/Typography/Typography'
import useRouter from '../../../../hooks/useRouter'
import { routes } from '../../../../router'
import { HealthSystemsProps } from './types'
import { Chips } from 'components/Chips/Chips'
import './styles.scss'

export const HealthSystems = ({
  healthSystems,
  idMyHealthSystem
}: HealthSystemsProps) => {
  const { push } = useRouter()

  const onOpenHs = (id: string) =>
    push(`${routes.myCommunity}${routes.healthSystem}/${id}/`)

  return (
    <div className="health-systems-list">
      {!!healthSystems.length ? (
        <div className="health-systems-list__list">
          {healthSystems.map((i) => (
            <div
              key={i.uuid}
              onClick={() => onOpenHs(i.uuid)}
              className="health-systems-list__list-item"
            >
              <Typography.Body1 className="mb-4">{i.name}</Typography.Body1>
              {idMyHealthSystem && idMyHealthSystem === i.uuid && (
                <Chips grey key={i.uuid}>
                  My health system
                </Chips>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="health-systems-list__empty row justify-center">
          <Typography.Headline6 className="row justify-center">
            The list is empty
          </Typography.Headline6>
        </div>
      )}
    </div>
  )
}
